<template>
  <div class="widget progress-bar" ref="board">
    <div class="widget-title">
      {{ title('Progress Bar') }}
    </div>

    <div class="widget-content">
      <template v-for="(value, key) in types">
        <template v-if="settings.value[key]">
          <h2 :key="key">{{value.label}}</h2>

          <div class="chart" :ref="'chartdiv_' + key" :id="'chartdiv_' + key" :key="key"></div>
        </template>
      </template>
    </div>
  </div>
</template>


<script>
    /* eslint-disable no-unused-vars */
    import {mapGetters} from "vuex";
    import widgetHelper from "@/mixins/widgetHelper";

    import * as am5 from '@amcharts/amcharts5';
    import * as am5xy from '@amcharts/amcharts5/xy';
    import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';

    export default {
        name: "ProgressBar",
        mixins: [widgetHelper],
        computed: {
            ...mapGetters(["streams", "collectives"]),

            getData() {
                const users = this.selectedUsers.map(i => ({
                    ...i,
                    name: i.full_name
                }));
                const shifts = this.selectedShifts;
                const roles = this.selectedRoles;
                const collectives = this.selectedCollectives;

                return [
                    ...users,
                    ...shifts,
                    ...roles,
                    ...collectives,
                ];
            }
        },
        data() {
            return {
                types: {
                    'show_daily': {
                        label: 'Daily',
                        value: 'daily'
                    },
                    'show_weekly': {
                        label: 'Weekly',
                        value: 'weekly'
                    },
                    'show_monthly': {
                        label: 'Monthly',
                        value: 'monthly'
                    },
                }
            };
        },
        watch: {
            getData(newValue) {
                if (newValue) {
                    this.init(newValue)
                }
            }
        },
        mounted(){
            this.init(this.getData)
        },
        methods: {
            init(data) {
                const newDate = this.getChartData(data);

                Object.keys(this.types).forEach(k => {

                    if (!this.settings.value[k]) {
                        return
                    }

                    const arr = document.querySelectorAll('#chartdiv_' + k);

                    arr.forEach(item => {
                        const root = am5.Root.new(item);

                        root.setThemes([
                            am5themes_Animated.new(root)
                        ]);

                        let chart = root.container.children.push(
                            am5xy.XYChart.new(root, {
                                panY: false,
                                layout: root.verticalLayout
                            })
                        );

                        // Create Y-axis
                        let yAxis = chart.yAxes.push(
                            am5xy.ValueAxis.new(root, {
                                renderer: am5xy.AxisRendererY.new(root, {})
                            })
                        );

                        // Create X-Axis
                        const xRenderer = am5xy.AxisRendererX.new(root, {})
                        let xAxis = chart.xAxes.push(
                            am5xy.CategoryAxis.new(root, {
                                renderer: xRenderer,
                                categoryField: "name",
                                bullet: function (root, axis, dataItem) {
                                    return am5xy.AxisBullet.new(root, {
                                        location: 0.5,
                                        sprite: am5.Picture.new(root, {
                                            width: 100,
                                            height: 100,
                                            centerY: am5.percent(-5),
                                            centerX: am5.p50,
                                            src: dataItem.dataContext.logo
                                            // src: "https://cv-media-files.s3.us-west-2.amazonaws.com/team_caryn.png"
                                        })
                                    });
                                }
                            })
                        );

                        xRenderer.labels.template.setAll({
                            paddingTop: 110
                        });

                        xAxis.data.setAll(newDate);

                        let series = chart.series.push(
                            am5xy.ColumnSeries.new(root, {
                                name: k.name,
                                xAxis: xAxis,
                                yAxis: yAxis,
                                valueYField: `goal_${k}`,
                                categoryXField: "name"
                            })
                        );

                        series.data.setAll(newDate);

                        series.appear();

                        series.bullets.push(function (root) {
                            return am5.Bullet.new(root, {
                                locationX: 0.5,
                                locationY: 1,
                                sprite: am5.Label.new(root, {
                                    text: `{goal_${k}}`,
                                    fill: '#579fc1',

                                    shadowColor:  am5.color(0x000000),
                                    shadowBlur: 2,
                                    shadowOffsetX: 0,
                                    shadowOffsetY: 0,
                                    shadowOpacity: 0.2,

                                    centerX: am5.percent(50),
                                    centerY: am5.percent(100),
                                    populateText: true
                                })
                            });
                        });


                        let series2 = chart.series.push(
                            am5xy.LineSeries.new(root, {
                                name: k.name,
                                xAxis: xAxis,
                                yAxis: yAxis,
                                valueYField: `current_${k}`,
                                categoryXField: "name"
                            })
                        );

                        series2.strokes.template.setAll({
                            strokeWidth: 3,
                        });

                        series2.data.setAll(newDate);

                        series2.bullets.push(function () {
                            return am5.Bullet.new(root, {
                                sprite: am5.Label.new(root, {
                                    text: `{current_${k}}`,
                                    centerX: am5.percent(50),
                                    centerY: am5.percent(100),
                                    populateText: true
                                })
                            });
                        });
                        series2.bullets.push(function () {
                            return am5.Bullet.new(root, {
                                sprite: am5.Circle.new(root, {
                                    strokeWidth: 3,
                                    stroke: series2.get("stroke"),
                                    radius: 5,
                                    fill: root.interfaceColors.get("background")
                                })
                            });
                        });

                        // Add legend
                        // let legend = chart.children.push(am5.Legend.new(root, {}));
                        // legend.data.setAll(chart.series.values);

                        // Add cursor
                        // chart.set("cursor", am5xy.XYCursor.new(root, {}));
                    });

                })

            },

            getChartData(data) {
                const isAmount = this.settings.value.target_type !== 'Count';
                const targetFiled = 'goal';
                let saleFiled = isAmount ? 'gross_sale' : 'count';
                if (this.settings.value.use_net_amount) {
                    saleFiled = isAmount ? 'net_sale' : 'net_count';
                }

                return data.map((k, i) => {
                    const item = {};

                    Object.keys(this.types).forEach(type => {
                        item[`group`] = this.types[type].label;

                        item[`goal_${type}`] = k[this.types[type].value][targetFiled];
                        item[`current_${type}`] = k[this.types[type].value][saleFiled];

                        item[`name`] = k.name;

                        item[`logo`] = k.logo;
                    });

                    return item
                });
            }
        }
    };
</script>


<style lang="scss" scoped>
  .widget-content {
    h2 {
      text-align: center;
      margin: 5px auto;
    }
  }

  .chart {
    height: 100vh;
    width: 100%;
    background: rgb(255 255 255 / 76%);
  }
</style>
